import React from 'react';
import {_t} from "../../../../js/app/common/utils/locale";

export default class InfoCardClusterLogin extends React.Component {

    render() {
        return (
            <div className="info-card info-card__greeting">
                <h4 className="title title--h4 info-card__title">
                    {_t('Welcome to')} <br/>
                    {_t('Cluster Administrative panel')}
                </h4>
                <picture className="info-card__picture">
                    <img src="/v2/images/cluster/cluster-login.svg" alt={_t('Cluster Administrative panel')}/>
                </picture>
                <ul className="info-card__advantages">
                    <li>{_t('Manage multiple companies')}</li>
                    <li>{_t('Easily clone new ones')}</li>
                    <li>{_t('Manage user access')}</li>
                </ul>
            </div>
        );
    }

}